define('SearchSpring.Facets.Translator', [
	'jQuery',
	'SC.Configuration',
	'underscore',
	'UrlHelper'
], function SearchSpringFacetsTranslator(
	jQuery,
	Configuration,
	_,
	UrlHelperModule
) {
	'use strict';

	// SCA 2026 exports { UrlHelper }; older SCA exported the helper directly
	var UrlHelper = UrlHelperModule.UrlHelper || UrlHelperModule;

	var defaultConfig = {
		fallbackUrl: 'search',
		defaultShow: null,
		defaultOrder: null,
		defaultDisplay: null,
		facets: [],
		facetDelimiters: {
			betweenFacetNameAndValue: '/',
			betweenDifferentFacets: '/',
			betweenDifferentFacetsValues: ',',
			betweenRangeFacetsValues: 'to',
			betweenFacetsAndOptions: '?',
			betweenOptionNameAndValue: '=',
			betweenDifferentOptions: '&'
		}
	};

	// @constructor @param {Array}facets @param {Object} options @param {Object} configuration

	var FacetsTranslator = function (
		facets,
		options,
		configuration,
		category
	) {
		var facetsToInclude = [];

		// Enforces new
		if (!(this instanceof FacetsTranslator)) {
			return new FacetsTranslator(facets, options, configuration, category);
		}
		// Facets go Here
		this.facets = [];

		// Other options like page, view, etc. goes here
		this.options = {};

		// This is an object that must contain a fallbackUrl and a lists of facet configurations
		this.configuration = configuration || defaultConfig;

		// Get the facets that are in the sitesettings but not in the config.
		// These facets will get a default config (max, behavior, etc.) - Facets.Translator
		// Include facet aliases to be conisdered as a possible route

		/*
            _.each(facetsData, function (facet) {
                if (facet.facetfieldid !== 'commercecategory') {
                    facetsToInclude.push(facet.facetfieldid);
                    // If the facet has an urlcomponent defined, then add it to the possible values list.
                    if (facet.urlcomponent) {
                        facetsToInclude.push(facet.urlcomponent);
                    }
                }
            });
        */
		facetsToInclude = _.union(facetsToInclude, _.pluck(Configuration.get('facets'), 'id'));
		facetsToInclude = _.uniq(facetsToInclude);

		this.facetsToInclude = facetsToInclude;

		// Searchspring won't run on category pages
		this.isCategoryPage = false;
		this.isSearchSpring = true;

		// We cast on top of the passed in parameters.
		if (facets && options) {
			this.facets = facets;
			this.options = options;
		} else if (_.isString(facets)) {
			// It's a url
			this.parseUrl(facets);
		} else if (facets) {
			// It's an API option object
			this.parseOptions(facets);
		} else if (options) {
			this.options = options;
		}
	};

	_.extend(FacetsTranslator.prototype, {
		// @property {Object}defaultFacetConfig
		defaultFacetConfig: {
			behavior: 'single',
			max: 5
		},

		// @method getFacetsToInclude
		getFacetsToInclude: function getFacetsToInclude() {
			return this.facetsToInclude;
		},

		// @method parseUrl Url strings get translated into the differnts part of the object, facets and options
		// @param {String} url
		parseUrl: function parseUrl(pUrl) {
			var tmpOptions = {};
			var facetName;
			var facetValue;
			var optionsToken;
			var optionName;
			var optionValue;
			var optionIsFacet;

			// We remove a posible 1st / (slash)
			var url = pUrl[0] === '/' ? pUrl.substr(1) : pUrl;

			// given an url with options we split them into 2 strings (options and facets)
			var facetsAndOptions = url.split(
				this.configuration.facetDelimiters.betweenFacetsAndOptions
			);
			var facets
                = facetsAndOptions[0] && facetsAndOptions[0] !== this.configuration.fallbackUrl
                	? facetsAndOptions[0]
                	: '';
			var options = facetsAndOptions[1] || '';

			// The facet part of the url gets splitted and computed by pairs
			var facetTokens = facets.split(
				new RegExp(
					'[\\'
					+ this.configuration.facetDelimiters.betweenDifferentFacets
					+ '\\'
					+ this.configuration.facetDelimiters.betweenFacetNameAndValue
					+ ']+',
					'gi'
				)
			);

			while (facetTokens.length > 0) {
				facetName = facetTokens.shift();
				facetValue = facetTokens.shift();

				if (!this.facetIsParameter(facetName)) {
					this.parseUrlFacet(facetName, facetValue);
				}
			}

			// The same for the options part of the url
			optionsToken = options.split(
				new RegExp(
					'[\\'
					+ this.configuration.facetDelimiters.betweenOptionNameAndValue
					+ '\\'
					+ this.configuration.facetDelimiters.betweenDifferentOptions
					+ ']+',
					'gi'
				)
			);

			while (optionsToken.length > 0) {
				optionName = optionsToken.shift();
				optionValue = optionsToken.shift();
				optionIsFacet = _.contains(this.facetsToInclude, optionName);

				if (optionIsFacet && this.facetIsParameter(optionName)) {
					this.parseUrlFacet(optionName, optionValue);
				}

				tmpOptions[optionName] = optionValue;
			}

			this.parseUrlOptions(tmpOptions);
		},

		// @method facetIsParameter
		// Given a facet name, returns true if the facet needs to be interpreted as an url parameter, false otherwise.
		// @param {String} facet_name
		facetIsParameter: function facetIsParameter() {
			return true; // ALL FACETS ARE PARAMETERS IN SEARCH
		},

		/*
        @method sanitizeValue
        Translates values that came from the url into JS data types that this objects know of
        Examples for different types:

        range/10to100 gets translated to {from: '10', to: '100'}
        range/100 gets translated to {from: '0', to: '100'}
        multi/1,2,3 gets translated to ['1', '2', '3']
        */
		sanitizeValue: function sanitizeValue(value, behavior) {
			var parsedValue;
			var tokens;

			switch (behavior) {
				case 'range':
					// we return an object like {from: string, to: string }
					if (_.isString(value)) {
						if (
							value.indexOf(
								this.configuration.facetDelimiters.betweenRangeFacetsValues
							) !== -1
						) {
							tokens = value.split(
								this.configuration.facetDelimiters.betweenRangeFacetsValues
							);
							parsedValue = { from: tokens[0], to: tokens[1] };
						} else {
							parsedValue = { from: '0', to: value };
						}
					} else {
						parsedValue = value;
					}

					break;
				case 'multi':
					// we always return an array for a multi value
					if (
						value.indexOf(
							this.configuration.facetDelimiters.betweenDifferentFacetsValues
						) !== -1
					) {
						parsedValue = value.split(
							this.configuration.facetDelimiters.betweenDifferentFacetsValues
						);
					} else {
						parsedValue = [value];
					}

					break;
				default:
					parsedValue = value;
			}

			return parsedValue;
		},

		// @method getUrlFacetValue
		// Returns the value of an active facet by the facet URL component
		// @param {String} facet_url
		getUrlFacetValue: function getUrlFacetValue(facetUrl) {
			return (
				_.find(this.facets, function (facet) {
					return facet.url === facetUrl;
				}) || {}
			).value;
		},

		// @method getFacetValue:
		// Returns the value of an active facet by the facet id
		// @param {String} facet_id
		getFacetValue: function getFacetValue(facetId) {
			return (
				_.find(this.facets, function (facet) {
					return facet.id === facetId;
				}) || {}
			).value;
		},

		// @method getAllFacets
		// @returns {Array} a copy of the internal array of facets containing values and configuration
		getAllFacets: function getAllFacets() {
			return this.facets.slice(0);
		},

		// @param getOptionValue
		// Returns the value of an active options or it's default value
		getOptionValue: function getOptionValue(optionId) {
			return this.options[optionId] || null;
		},

		// Modified since searchspring doesn't want us encoding everything;
		encodeComponent: function encodeComponent(val) {
			return val;
		},

		// @param parseUrlFacet
		// for a given name value, it gets the config, sanitize the value and stores it all in the internal facets array
		// @param {String} @param {String} value
		parseUrlFacet: function parseUrlFacet(name, value) {
			// Gets the config for the current facet
			var config = this.getFacetConfig(name, 'id');
			var facetsValues;
			var self = this;

			if (config.id === 'commercecategoryname' || config.id === 'category' || !name) {
				return;
			}

			facetsValues
                = value && value.split(this.configuration.facetDelimiters.betweenDifferentFacetsValues);

			facetsValues = _.map(facetsValues, function (pVal) {
				var val = decodeURIComponent(pVal);
				val = self.encodeComponent(val);

				return val;
			});

			this.facets.push({
				config: config,
				id: config.id,
				url: config.id,
				value: this.sanitizeValue(
					facetsValues.join(this.configuration.facetDelimiters.betweenDifferentFacetsValues),
					config.behavior
				),
				isParameter: config.isParameter
			});
		},

		// @method parseFacet:
		// Same as parseUrlFacet but from id
		// @param facet_id @param value
		parseFacet: function parseFacet(facetId, value) {
			// Gets the config for the current facet
			var config = this.getFacetConfig(facetId, 'id');

			this.facets.push({
				config: config,
				id: config.id,
				url: config.id,
				value: this.sanitizeValue(value, config.behavior),
				isParameter: config.isParameter
			});
		},

		// @method parseUrlOptions:
		// Sets options from the options argument or sets default values
		// @param {Object} options
		parseUrlOptions: function parseUrlOptions(options) {
			this.options.show = options.show || this.configuration.defaultShow;
			this.options.order = options.order || this.configuration.defaultOrder;
			this.options.page = parseInt(options.page, 10) || 1;
			this.options.display = options.display || this.configuration.defaultDisplay;
			this.options.keywords = options.keywords
				? decodeURIComponent(options.keywords)
				: this.configuration.defaultKeywords;
		},

		// facet@method getFacetConfig
		// Gets the configuration for a given facet by id,
		// @param {String}name @param {String}by
		getFacetConfig: function getFacetConfig(name) {
			var result = _.find(this.configuration.facets, function (facet) {
				return facet.id === name;
			});

			result
                = result
                || _.find(this.configuration.facets, function (facet) {
                	return facet.url === name;
                });

			return (
				result
				|| _.extend(
                	{ id: name, name: name, url: name, isParameter: undefined },
                	this.defaultFacetConfig
				)
			);
		},

		// @method getUrl
		// Gets the url for current state of the object
		getUrl: function getUrl() {
			var url = this.categoryUrl || '';
			var self = this;
			var sortedFacets;
			var facetsAsOptions;

			var i;
			var facet;
			var name;
			var value;

			var tmpOptions = {};
			var separator = this.configuration.facetDelimiters.betweenOptionNameAndValue;

			var facetsOptionObj;
			var tmpOptionKeys;
			var tmpOptionVals;

			// Prepares seo limits
			var facetsSeoLimits = {};

			if (SC.ENVIRONMENT.jsEnvironment === 'server') {
				facetsSeoLimits = {
					numberOfFacetsGroups:
                        (this.configuration.facetsSeoLimits
                        && this.configuration.facetsSeoLimits.numberOfFacetsGroups)
                        || false,
					numberOfFacetsValues:
                        (this.configuration.facetsSeoLimits
                        && this.configuration.facetsSeoLimits.numberOfFacetsValues)
                        || false,
					options:
                        (this.configuration.facetsSeoLimits
                        && this.configuration.facetsSeoLimits.options)
                        || false
				};
			}

			// If there are too many facets selected
			if (
				facetsSeoLimits.numberOfFacetsGroups
				&& this.facets.length > facetsSeoLimits.numberOfFacetsGroups
			) {
				return '#';
			}

			// Encodes the other Facets
			sortedFacets = _.sortBy(this.facets, 'url');
			facetsAsOptions = [];

			for (i = 0; i < sortedFacets.length; i++) {
				facet = sortedFacets[i];

				// Category should be already added
				if (facet.id === 'commercecategoryname' || facet.id === 'category') {
					break;
				}

				name = facet.url || facet.id;
				value = '';

				switch (facet.config.behavior) {
					case 'range':
						facet.value
                            = typeof facet.value === 'object'
                            	? facet.value
                            	: { from: 0, to: facet.value };
						value
                            = facet.value.from
                            + self.configuration.facetDelimiters.betweenRangeFacetsValues
                            + facet.value.to;
						break;
					case 'multi':
						value = facet.value
							.sort()
							.join(self.configuration.facetDelimiters.betweenDifferentFacetsValues);

						if (
							facetsSeoLimits.numberOfFacetsValues
							&& facet.value.length > facetsSeoLimits.numberOfFacetsValues
						) {
							return '#';
						}

						break;
					default:
						value = facet.value;
				}

				if (self.facetIsParameter(name)) {
					facetsAsOptions.push({ facetName: name, facetValue: value });
				} else {
					// Do not add a facet separator at the begining of an url
					if (url !== '') {
						url += self.configuration.facetDelimiters.betweenDifferentFacets;
					}

					url += name + self.configuration.facetDelimiters.betweenFacetNameAndValue + value;
				}
			}

			url = url !== '' ? url : '/' + this.configuration.fallbackUrl;

			// Encodes the Options
			tmpOptions = {};
			separator = this.configuration.facetDelimiters.betweenOptionNameAndValue;

			if (this.options.order && this.options.order !== this.configuration.defaultOrder) {
				tmpOptions.order = 'order' + separator + this.options.order;
			}

			if (this.options.page && parseInt(this.options.page, 10) !== 1) {
				tmpOptions.page = 'page' + separator + encodeURIComponent(this.options.page);
			}

			if (
				this.options.show
				&& parseInt(this.options.show, 10) !== this.configuration.defaultShow
			) {
				tmpOptions.show = 'show' + separator + encodeURIComponent(this.options.show);
			}

			if (this.options.display && this.options.display !== this.configuration.defaultDisplay) {
				tmpOptions.display = 'display' + separator + encodeURIComponent(this.options.display);
			}

			if (this.options.keywords && this.options.keywords !== this.configuration.defaultKeywords) {
				tmpOptions.keywords
                    = 'keywords' + separator + encodeURIComponent(this.options.keywords);
			}

			for (i = 0; i < facetsAsOptions.length; i++) {
				facetsOptionObj = facetsAsOptions[i];

				tmpOptions[facetsOptionObj.facetName]
                    = facetsOptionObj.facetName + separator + facetsOptionObj.facetValue;
			}

			tmpOptionKeys = _.keys(tmpOptions);
			tmpOptionVals = _.values(tmpOptions);

			// If there are options that should not be indexed also return #
			if (
				facetsSeoLimits.options
				&& _.difference(tmpOptionKeys, facetsSeoLimits.options).length
			) {
				return '#';
			}

			url += tmpOptionVals.length
				? this.configuration.facetDelimiters.betweenFacetsAndOptions
				+ tmpOptionVals.join(this.configuration.facetDelimiters.betweenDifferentOptions)
				: '';

			if (url && url[0] !== this.configuration.facetDelimiters.betweenDifferentFacets) {
				url = this.configuration.facetDelimiters.betweenDifferentFacets + url;
			}

			return UrlHelper.fixUrl(url);
		},

		// @method getCategoryUrl Returns the current category url
		getCategoryUrl: function getCategoryUrl() {
			return this.categoryUrl;
		},

		// @method getApiParams ESTA CAMBIADA
		// Gets the api parameters representing the current status of the object
		getApiParams: function getApiParams() {
			var params = {};
			var parts;
			var value;

			_.each(this.facets, function (facet) {
				switch (facet.config.behavior) {
					case 'range':
						value = (typeof facet.value === 'object') ? facet.value : { from: 0, to: facet.value };
						params['filter.' + facet.id + '.low'] = value.from;
						params['filter.' + facet.id + '.high'] = value.to;
						break;
					case 'multi':
						params['filter.' + facet.id] = facet.value.sort().join(','); // this coma is part of the api call so it should not be removed
						break;
					default:
						params['filter.' + facet.id] = facet.value;
				}
			});
			parts = this.options.order.split(':');
			params['sort.' + parts[0]] = parts[1];
			params.resultsPerPage = this.options.show;
			params.page = this.options.page;
			params.q = this.options.keywords;

			return params;
		},

		// @method cloneForFacetId
		// retruns a deep copy of this object with a new value for one facet,
		// if in a name value that is the same as what's in, it will take it out
		cloneForFacetId: function cloneForFacetId(facetId, facetValue) {
			// Using jQuery here because it offers deep cloning
			var facets = _.toArray(jQuery.extend(true, {}, this.facets));
			var options = jQuery.extend(true, {}, this.options);
			var currentFacet = _.find(facets, function (facet) {
				return facet.id === facetId;
			});
			var translator;

			if (currentFacet) {
				if (currentFacet.config.behavior === 'multi') {
					if (_.indexOf(currentFacet.value, facetValue) === -1) {
						currentFacet.value.push(facetValue);
					} else {
						currentFacet.value = _.without(currentFacet.value, facetValue);
					}

					if (currentFacet.value.length === 0) {
						facets = _.without(facets, currentFacet);
					}
				} else if (!_.isEqual(currentFacet.value, facetValue)) {
					currentFacet.value = facetValue;
				} else {
					facets = _.without(facets, currentFacet);
				}
			}

			options.page = 1;

			translator = new FacetsTranslator(
				facets,
				options,
				this.configuration,
				this.categoryUrl
			);

			if (!currentFacet) {
				translator.parseFacet(facetId, facetValue);
			}

			return translator;
		},

		// @method cloneWithoutFacetId
		// retruns a deep copy of this object without a facet,
		cloneWithoutFacetId: function cloneWithoutFacetId(facetId) {
			var facets = _.toArray(jQuery.extend(true, {}, this.facets));
			var options = jQuery.extend(true, {}, this.options);

			facets = _.without(
				facets,
				_.find(facets, function (facet) {
					return facet.id === facetId;
				})
			);

			return new FacetsTranslator(facets, options, this.configuration, this.categoryUrl);
		},

		// @method cloneWithoutFacets
		// Clones the translator removeing all the facets, leaving only options
		cloneWithoutFacets: function cloneWithoutFacets() {
			// Creates a new translator with the same params as this;
			var translator = new FacetsTranslator(
				this.facets.slice(),
				this.options,
				this.configuration,
				this.categoryUrl
			);

			_.each(translator.getAllFacets(), function (facet) {
				translator = translator.cloneWithoutFacetId(facet.id);
			});

			return translator;
		},

		// @method cloneForOption
		cloneForOption: function cloneForOption(optionId, optionValue) {
			var facets = _.toArray(jQuery.extend(true, {}, this.facets));
			var options = jQuery.extend(true, {}, this.options);

			options[optionId] = optionValue;
			return new FacetsTranslator(facets, options, this.configuration, this.categoryUrl);
		},

		// @method cloneForOptions
		// same as cloneForFacetId but for options instead of facets
		cloneForOptions: function cloneForOptions(object) {
			var facets = _.toArray(jQuery.extend(true, {}, this.facets));
			var options = jQuery.extend(true, {}, this.options, object);

			return new FacetsTranslator(facets, options, this.configuration, this.categoryUrl);
		},

		// @method cloneWithoutOption
		// same as cloneWithoutFacetId but for options instead of facets
		cloneWithoutOption: function cloneWithoutOption(optionId) {
			var facets = _.toArray(jQuery.extend(true, {}, this.facets));
			var options = jQuery.extend(true, {}, this.options);

			delete options[optionId];

			return new FacetsTranslator(facets, options, this.configuration, this.categoryUrl);
		},

		// @method resetAll
		// Returns a blank instance of itself
		resetAll: function resetAll() {
			return new FacetsTranslator([], {}, this.configuration, false);
		},

		// @method setLabelsFromFacets
		// This var the translator known about labels the api proportions
		// Tho this make the translator a bit less API agnostic
		// this step is totaly optional and it should work regardless of this step
		setLabelsFromFacets: function setLabelsFromFacets(facetsLabels) {
			this.facetsLabels = facetsLabels;
		},

		// @method getLabelForValue
		// If facets labels have been setted it will try to look for the label for the
		// [id, value] combination and return it's label, otherways it will return the value
		getLabelForValue: function getLabelForValue(id, value) {
			var label;
			var facet = _.filter(this.facetsLabels || [], function (facetLabel) {
				return facetLabel.id === id || facetLabel.url === id;
			});

			if (facet.length) {
				label = _.where(facet[0].values || [], { name: value });

				// if the value could not be found by name, look for url
				if (!label.length) {
					label = _.where(facet[0].values || [], { url: value });
				}

				if (label.length && label[0].label) {
					return label[0].label;
				}
			}

			return value;
		}
	});

	return FacetsTranslator;
});
